import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { UserAvatar } from "@/components/UserBits";

function WallItem({ t, i }) {
  const [on, setOn] = useState(t.hearted);
  const [n, setN] = useState(t.hearts);
  const toggle = async () => {
    try { const { data } = await api.post(`/allin/${t.id}/heart`); setOn(data.hearted); setN(data.hearts); }
    catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <li className={`relative rounded-3xl p-4 bg-white border border-pink-100 shadow-sm gift-pop ${i === 0 ? "ring-2 ring-rose-300" : ""}`} style={{ animationDelay: `${i * 0.06}s` }} data-testid={`thanks-wall-item-${t.id}`}>
      {i === 0 && <span className="absolute -top-2.5 left-4 px-2.5 h-5 rounded-full pink-gradient text-white text-[10px] font-extrabold tracking-wider flex items-center">LIEBLINGSSATZ</span>}
      <p className="font-display text-base font-bold text-slate-800 break-words">„{t.thank_msg}“</p>
      <div className="mt-3 flex items-center gap-2">
        <UserAvatar userId={t.to_id} name={t.to_name} picture="" size="w-7 h-7" text="text-[10px]" noStory />
        <p className="flex-1 min-w-0 text-xs text-slate-500 truncate"><b className="text-slate-700">{t.to_name}</b> an {t.from_name}</p>
        <button onClick={toggle} data-testid={`thanks-wall-heart-${t.id}`} aria-pressed={on}
          className={`inline-flex items-center gap-1 h-8 px-3 rounded-full text-sm font-bold transition-colors active:scale-95 ${on ? "bg-rose-500 text-white" : "bg-rose-50 text-rose-600 hover:bg-rose-100"}`}>
          <Heart className={`w-4 h-4 ${on ? "gift-heartbeat" : ""}`} fill={on ? "currentColor" : "none"} /> {n}
        </button>
      </div>
    </li>
  );
}

export function ThanksWall() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/allin/thanks-wall").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  if (!list) return null;
  return (
    <section className="rounded-3xl p-5 bg-gradient-to-br from-rose-50 via-white to-pink-50 border border-pink-100 space-y-4" data-testid="thanks-wall">
      <div className="flex items-center gap-3">
        <span className="w-11 h-11 shrink-0 rounded-2xl pink-gradient flex items-center justify-center text-xl gift-heartbeat">💖</span>
        <div><h2 className="font-display text-xl font-extrabold">Herzenswand</h2><p className="text-sm text-slate-500">Die liebsten Danke-Sätze der Woche – tippe aufs Herz für deinen Favoriten.</p></div>
      </div>
      {list.length === 0
        ? <p className="text-sm text-slate-400 text-center py-4" data-testid="thanks-wall-empty">Noch keine Danke-Sätze diese Woche – verschick ein Geschenk und mach den Anfang 💖</p>
        : <ul className="grid sm:grid-cols-2 gap-3 pt-1">{list.map((t, i) => <WallItem key={t.id} t={t} i={i} />)}</ul>}
    </section>
  );
}
